module.exports = __webpack_public_path__ + "img/audit_pass.20f2d033.png";